import Lockprocesing from './lockProcesing';
import { SIZE } from './constants';

export default Lockprocesing;
export { SIZE };